import createIcon from '../../createIcon';

/**
 * @component @name Css
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41IDE0VjEzSDExVjEzLjVIMTNWMTIuNUgxMC41QzkuOTUgMTIuNSA5LjUgMTIuMDUgOS41IDExLjVWMTBDOS41IDkuNDUgOS45NSA5IDEwLjUgOUgxMy41QzE0LjA1IDkgMTQuNSA5LjQ1IDE0LjUgMTBWMTFIMTNWMTAuNUgxMVYxMS41SDEzLjVDMTQuMDUgMTEuNSAxNC41IDExLjk1IDE0LjUgMTIuNVYxNEMxNC41IDE0LjU1IDE0LjA1IDE1IDEzLjUgMTVIMTAuNUM5Ljk1IDE1IDkuNSAxNC41NSA5LjUgMTRaTTE3IDE1SDIwQzIwLjU1IDE1IDIxIDE0LjU1IDIxIDE0VjEyLjVDMjEgMTEuOTUgMjAuNTUgMTEuNSAyMCAxMS41SDE3LjVWMTAuNUgxOS41VjExSDIxVjEwQzIxIDkuNDUgMjAuNTUgOSAyMCA5SDE3QzE2LjQ1IDkgMTYgOS40NSAxNiAxMFYxMS41QzE2IDEyLjA1IDE2LjQ1IDEyLjUgMTcgMTIuNUgxOS41VjEzLjVIMTcuNVYxM0gxNlYxNEMxNiAxNC41NSAxNi40NSAxNSAxNyAxNVpNOCAxMEM4IDkuNDUgNy41NSA5IDcgOUg0QzMuNDUgOSAzIDkuNDUgMyAxMFYxNEMzIDE0LjU1IDMuNDUgMTUgNCAxNUg3QzcuNTUgMTUgOCAxNC41NSA4IDE0VjEzSDYuNVYxMy41SDQuNVYxMC41SDYuNVYxMUg4VjEwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Css = createIcon('Css', [
  [
    'path',
    {
      d: 'M9.5 14V13H11V13.5H13V12.5H10.5C9.95 12.5 9.5 12.05 9.5 11.5V10C9.5 9.45 9.95 9 10.5 9H13.5C14.05 9 14.5 9.45 14.5 10V11H13V10.5H11V11.5H13.5C14.05 11.5 14.5 11.95 14.5 12.5V14C14.5 14.55 14.05 15 13.5 15H10.5C9.95 15 9.5 14.55 9.5 14ZM17 15H20C20.55 15 21 14.55 21 14V12.5C21 11.95 20.55 11.5 20 11.5H17.5V10.5H19.5V11H21V10C21 9.45 20.55 9 20 9H17C16.45 9 16 9.45 16 10V11.5C16 12.05 16.45 12.5 17 12.5H19.5V13.5H17.5V13H16V14C16 14.55 16.45 15 17 15ZM8 10C8 9.45 7.55 9 7 9H4C3.45 9 3 9.45 3 10V14C3 14.55 3.45 15 4 15H7C7.55 15 8 14.55 8 14V13H6.5V13.5H4.5V10.5H6.5V11H8V10Z',
      key: '1167mx',
    },
  ],
]);

export default Css;
